<div class="container m-auto flex flex-col h-screen justify-between ">

  <app-navbar></app-navbar>

  <div class="prose lg:prose-xl dark:prose-invert" >

    <h1>Terms of Use</h1>

    <p class="text-muted">Last Updated: October 10, 2023</p>

    <p>
      Welcome to GameFace, a service provided by Groupwork Guru (hereafter referred to as "We" or "Us"), that aims to gamify the classroom. By accessing and using Gameface (hereafter referred as the "Service"), you agree to abide by the following Terms of Use, as well as our <a href="/privacy">Privacy Policy</a> and any applicable laws and regulations.
    </p>
    <p>
      Please read these terms carefully to understand your rights and obligations when using GameFace.
    </p>


    <h2>1. Use of Our Service</h2>

    <p>
      It is expected that you will be using this Service as either a staff member or student of an education provider (hereafter refered to as your Institution).
    </p>
    <p>
      Subject to the terms in this policy, in conjunction with the terms of any other agreement between Us and your Institution, you are hereby granted a non-exclusive, limited, non-transferable, license to use the Service. The license shall terminate if you violate any of these restrictions.
    </p>
    <p>
      Children under the age of 13 are prohibited from using the Service.
    </p>


    <h2>2. Prohibited conduct</h2>

    <p>
      You agree not to engage in any of the following prohibited activities:
    </p>

    <ul>
      <li>
        Use the Service for any unlawful, fraudulent, or malicious purposes.
      </li>
      <li>
        Interfere with the functioning of the Service or any of it's infrastructure.
      </li>
      <li>
        Impersonate any person or entity.
      </li>
      <li>
        Engage in any form of harassment or threatening behavior.
      </li>
      <li>
        Upload, post, or share any content that is inappropriate or offensive.
      </li>
    </ul>


    <h2>3. Intellectual Property</h2>

    <p>
      This Service includes features that allow you to upload content such as quizes and other education material. You retain ownership of any intellectual property rights that you hold for any such user-generated content.
    </p>
    <p>
      This Service is protected by copyright, trademark, and other intellectual property laws. Notwithstanding user-generated content as described above, all rights to the content, services, and features of the Service are reserved to Us. You agree not to reproduce, modify, distribute, or create derivative works from the content without our explicit permission.
    </p>

    <h2>4. Disclaimer</h2>

    <p>
      We make no warranties regarding the accuracy, completeness, or reliability of the educational content provided through the Service.
    </p>
    <p>
      Your use of this Service is at your own risk. It is provided "as is," and we do not guarantee that it will be uninterrupted, error-free, or free of harmful components.
    </p>
    <p>
      In no event shall We be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use this Service. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.
    </p>

    <h2>5. Modifications</h2>

    <p>
      We may revise these terms of service at any time without notice. By using the Service you are agreeing to be bound by the then current version of these terms of service.
    </p>

    <h2>6. Contact</h2>
    <p>
      For any questions or concerns please contact info&#64;groupworkguru.com
    </p>
  </div>

  <app-footer></app-footer>
</div>
